module.exports = __webpack_public_path__ + "img/icon_tips2.07f0ce90.png";